<div class="forgotten-password-title">
  <p class="reset-pwd-title">{{'common.text_account_profile_resetPassword'|cxTranslate}}</p>
  <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
    <img src="/icons/close-light-grey.svg" alt="" width="20" />
  </button>
</div>
<mat-dialog-content class="reset-password-content">
  <div class="forgotten-password">
    <div class="description">
      {{'common.forgottenPwd_description'| cxTranslate}}
    </div>
    <div class="email-forgotpwd">
      <p>{{'common.forgottenPwd_email'|cxTranslate}}</p>
    </div>
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <input type="email" id="email" formControlName="email">
      </div>
      @if (myForm.get('email').invalid && (myForm.get('email').dirty || myForm.get('email').touched)) {
      <div>
        @if (myForm.get('email').errors['required']) {
        <div class="error-msg">
          {{'common.forgottenPwd_email_invalid'|cxTranslate}}</div>
        }
        @if (myForm.get('email').errors['email']) {
        <div class="error-msg">
          {{'common.forgottenPwd_email_invalid'|cxTranslate}}</div>
        }
      </div>
      }
      <button type="submit" class=" btn btn-block btn-primary reset-btn text-uppercase" [disabled]="myForm.invalid">
        {{'common.text_account_profile_resetPassword'|cxTranslate}}
        <img src="/icons/link-dark-grey.svg" alt="" class="icon-right">
      </button>
    </form>
  </div>
</mat-dialog-content>